<template>
  <section
    ref="container"
    v-loading="loading"
    class="page-container"
  >
    <div
      class="main-header ">
      <div
        class="flex-sb type-margin">
        <div class="">
          <div class="header-title flex">
            <span
              v-if="merchant_platform"
              class="table-icon__img icon">
              <img :src="getOptionName('serverTypeIcon',merchant_platform)" >
            </span>
            <span class="icon" >
              <font-awesome-icon
                icon="ticket-alt"
                class="icon-color"/>
            </span>
            <span class="icon" >
              <span class="button-radius">{{detailData.type_language}}</span>
            </span>
            <span
              class="hcid ticket-number"> <span class="number-color">{{detailData.ticket_number}}</span></span>
          </div>

          <div class="header-title flex">
            <h3>{{ detailData.subject }}</h3>
          </div>
          <div class="flex flex-inline">
            <div>
              <span
                class="status-bar-span"
                :class="{
                  'pending':detailData.status==2,
                  'yellow':detailData.status==1,
                  'green':detailData.status==3
                }"
              >{{detailData.status_language}}</span>
            </div>
            <div>
              <span
                class="span-status-stts"
                :class="{
                  'orange-light': [1, 3,5].includes(detailData.stts)&&detailData.type==2||detailData.type==3&&[101,301].includes(detailData.stts),
                  'yellow-dark':[0].includes(detailData.stts)&&detailData.type==2||detailData.type==4&&[1].includes(detailData.stts)||(detailData.type==5||detailData.type==6||detailData.type==3)&&[0].includes(detailData.stts),
                  'blue': [2,4].includes(detailData.stts)&&detailData.type==2||detailData.type==4&&[4].includes(detailData.stts)||detailData.type==3&&[201,501].includes(detailData.stts)||detailData.type==6&&[1].includes(detailData.stts),
                  'green': [6].includes(detailData.stts)&&detailData.type==2||detailData.type==4&&[2].includes(detailData.stts)||detailData.type==3&&[601].includes(detailData.stts)||detailData.type==5&&[1].includes(detailData.stts)||detailData.type==6&&[3].includes(detailData.stts),
                  'red': [6].includes(detailData.stts)&&detailData.type==3||detailData.type==4&&[3].includes(detailData.stts)||detailData.type==3&&[401].includes(detailData.stts),
                  'purple': [2].includes(detailData.stts)&&detailData.type==6,
                }"
              >{{detailData.stts_language}}</span>
            </div>
            <span class="header-date">Created</span>
            <span class="number-color number-fontsize">{{ detailData.created_at }}</span>
            <span class="header-date">Updated</span>
            <span class="number-color number-fontsize">{{ detailData.updated_at }}</span>

          </div>
        </div>
        <div class="form-item">
          <span>Assignee</span>
          <span>

            <v-select
              v-model="assignee"
              icon="user-nurse"
              :list="assigneeList"
              :clearable="true"
              @change="selectAssignee"
            />
          </span>
        </div>
      </div>
    </div>


    <div
      class="main-container">
      <div
        class="main-edit">
        <section>
          <edit-policy
            ref="edit-policy"
            :ticketId="ticketId"
            :renewOrderSn="renew_order_sn"
            :orderId="detailData.relation.order_id"
            :form="policyData"
            :relationForm="relationForm"
            :endorseOrderId="detailData.relation.endorse_order_id"
            :action="detailData.relation.action"
            :isBeginEndorsement="isBeginEndorsement"
            :isEndorsement="true"
            @cancel="closeMainRightEndorsement"
            @nextStep="nextStep"
            @save="handleTicketDetail" />
        </section>
        <!--        <section v-if="showEndorsementQuoteInfo">-->
        <!--          <view-endorsement-quote-->
        <!--            :form="endorsementQuote.new_data"-->
        <!--            :ticketId="ticketId"-->
        <!--            :orderId="detailData.relation.order_id"-->
        <!--            :oldForm="endorsementQuote.previous_data"-->
        <!--            :action="detailData.relation.action"-->
        <!--            @back="closeMainRightEndorsement" />-->
        <!--        </section>-->
      </div>
    </div>
    <!--    <to-top-->
    <!--      :el='container'></to-top>-->

    <endors-renew-tips
      ref="renew-tips"
      :stts="renewStts"
      :renewOrderSn="renew_order_sn"
      @continue="tipsContinue"></endors-renew-tips>

  </section>
</template>
<script>

import {
  getTicketDetail,
  getTicketRemark,
  setTicketCs,

} from '@/api/ticket'
import {getAccountDetail} from '@/api/account'
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinPolicyholderDetail from '@/mixins/policyholader-detail'

import {
  getPolicyDetail,
} from '@/api/policy'


import EditPolicy from './components/edit-policy'
import endorsRenewTips from '@/views/components/dialogs/endors-renew-tips'
export default {
  name: 'Detail',
  components: {
    EditPolicy,
    endorsRenewTips
  },
  mixins: [MixinOptions,MixinPolicyholderDetail],
  data() {
    return {
      loading: false,
      initContent: '',
      way: '',
      container: null,
      policyData: {},
      detailData: {
        relation:{}
      },
      relationForm:{},
      customer_profile:{},
      renew_order_sn:'',
      assignee: '',
      renewStts: 0,

    }
  },
  computed: {
    ...mapState('common', ['globalOptions']),
    ...mapState('ticket', ['ticketData']),
    merchant_platform(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform
    },
    ticketId() {
      let {ticket_id} =this.$route.query||{}
      return ticket_id
    },
    isBeginEndorsement() {
      let {isBeginEndorsement} =this.$route.query||{}
      return isBeginEndorsement
    },
    relationOrderId() {
      const { relation } = this.detailData || {}
      const { order_id } = relation || {}
      return order_id||''
    },
    customerId() {
      return this.detailData.customer_id
    },
    productId(){
      let {product_id=''} =this.$route.query||{}
      return product_id||''
    }
  },
  watch: {
    relationOrderId: {
      immediate: true,
      handler(val) {
        if(val) {
          let params = {
            order_id: this.relationOrderId,
            is_refresh_user:1
          }
          this.getPolicyData(true,params)
        }
      }
    },
    ticketId: {
      immediate: true,
      async handler(val) {
        if(val)
        {
          await this.network().getTicketDetail()
        }
      }
    },
    customerId:{
      immediate:true,
      handler(val){
        if(val)
          this.network().getAccountDetail({customer_id:val})
      }
    },
  },
  created(){
    // this.container = this.$refs['container'].parentElement
  },
  methods: {
    handleTicketDetail(){
      this.closeMainRightEndorsement()
    },
    async handleUpdateDetail(){
      const { endorse_order_id, order_id } = this.detailData.relation||{}
      const orderId = endorse_order_id? endorse_order_id: order_id
      let params = {
        order_id: orderId,
        pcy_id: this.pcyId,
        is_refresh_user:1
      }
      if(this.productId)
        await this.network().getPolicyDetail(false,params)
    },
    tipsContinue(){
      switch(this.step){
        case 0:
          // begin endorsement
          this.beginEndorsement()
          break
        case 1:
          // edit draft
          this.event().onEditEndorsementDraft()
          break
        case 2:
          // kyc -> next
          this.$refs['edit-policy'].handlerNext()
          break
        case 3:
          // kyc -> next -> save
          this.$refs['edit-policy'].handlerSaveDraft()
          break
        case 4:
          // kyc -> next -> deliver
          this.$refs['edit-policy'].onDeliver()
          break
        case 5:
          // change claim status -> submit
          this.$refs['change-claim-status'].network().setClaimStatus()
          break
        case 6:
          // detail -> click Change Claim Status btn
          this.$refs['change-claim-status'].changeDialog()
          break
      }
    },
    showTips(){
      this.$refs['renew-tips'].changeDialog()
    },

    nextStep(step){
      this.step = step
      this.showTips()
    },
    // endorsement 顯示主頁
    closeMainRightEndorsement() {
      this.$router.push({
        path:'/tickets/detail',
        query:{
          ticket_id:this.ticketId
        }
      })
    },
    selectAssignee(id) {
      id = id?id:0
      this.network().setTicketCs({
        ticket_id:[this.ticketId],
        assignee_id: id
      })
    },
    async getPolicyData(isRelation = false,params){
      if(this.productId)
        await this.network().getPolicyDetail(isRelation,params)
    },
    network() {
      return {
        getTicketDetail: async (params = {}) => {
          const { data } = await getTicketDetail({
            id: this.ticketId,
            type: 0,
            ...params
          })
          this.detailData = data
          this.assignee = this.detailData.cs_id
          await this.handleUpdateDetail()
        },
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        getRemarkDetail: async () => {
          const { data } = await getTicketRemark({
            ticket_id: this.ticketId,
          })
          this.remarkDetail = data
        },
        addTicketRemark: async params => {
          const { data } = await addTicketRemark(params)
          this.$refs['add-mark'].initData()
          this.handler().getUpdateDetailData()
          this.message = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
        },

        // 獲取 policy 詳情數據
        getPolicyDetail: async (isRelation,params) => {
          // this.loading = true
          const { data } = await getPolicyDetail(params,this.productId)

          if(data.pcy_id){
            this.renew_order_sn = data.renew_order_sn
            this.renewStts = data.renew_stts
            // return
          }
          if(isRelation) {
            this.relationForm = data
            return
          }
          // this.relationForm = data
          this.policyData = {...data}
          // this.loading = false
        },
        setTicketCs: async params => {
          const { data } = await setTicketCs(params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .none-data{
    color: #6A737D;
  }
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }

  .span-status{
    padding: 1px 8px;
    color: #fff;
    border-radius: 50px;
    font-size: 14px;
    margin-right: 10px;
    background: #fff;
  }
  .status-bar-span{
    padding: 1px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    background: #fff;
    margin-right: 15px;
  }
  .span-status-stts{
    //font-family: Inter;
    padding: 1px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    margin-right: 15px;
    color: #fff!important;
    //height: 18px;

    //background: #E36209;
    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .yellow{
    border: 1px solid #735C0F;
    color: #735C0F;
  }
  .pending{
    border: 1px solid #0366D6;
    color: #0366D6;
  }
  .green{
    border: 1px solid #22863A;
    color: #22863A;
  }
  .warning{
    padding: 20px 70px;
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      width: 100%;
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .middle-col {
      flex: 1;
      min-width: 600px;
      /*width: calc(100% - 280px)!important;*/
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
        display: inline-block;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        &.is_snooze{
          background: #DBAB09;
          border: 1px solid rgba(27, 31, 35, 0.15);
          color: #FFFFFF;
        }
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        li:first-child {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        li:last-child {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 70px 0px 70px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    .icon-color{
      color:#6A737D;
    }
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    ::v-deep .el-tabs--top{
      margin-top: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
    .type-margin{
      margin-bottom: 20px;
    }
  }
}
.bg-green {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #68C23A;
  color: white;
  p {
    padding-bottom: 5px;
  }
}
.bg-warning {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #e6a23d;
  color: white;
  p {
    padding-bottom: 5px;
  }
}
.bg-skyblue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #409eff;
  color: white;
  p {
    padding-bottom: 5px;
  }
}
.bg-blue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #d9ecff;
}
.bg-gray {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  background: #91939a;
  color: white;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
}
.bg-small-blue {
  background: #B3D9FF;
}
.bg-block {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
}
.bg-green {
  background: #28a745;
  color: white;
}
.bg-red {
  background: #D73A49;
  color: white;
}
.bg-danger {
  background: #f56c6d;
  color: white;
}
.bg-b3d9ff {
  background: #b3d9ff;
}
.bg-warning {
  background: #e6a23d;
  color: white;
  .label {
    color: white;
  }
  &__yellow {
    background: #FFFBDD;
    border-radius: 15px;
    border: 1px solid rgba(176, 136, 0, 0.2);
    .flex,.flex__button{
      .width-80{
        width: 80%;
      }
    }
  }
}
.bg-sky-blue {
  background: #409EFF;;
  color: white;
  .label {
    color: white;
  }
}
::v-deep .edit-container{
  padding: 0px!important;
}
.tr-margin{
  margin-bottom: 10px;
}
.tr-a{
  display: block;
}


.setting  .page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      width: 100%;
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .middle-col {
      flex: 1;
      min-width: 600px;
      /*width: calc(100% - 280px)!important;*/
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        text-decoration: none!important;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 70px 0px 70px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FFF!important;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
}
.bg-green {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #68C23A;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-warning {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #e6a23d;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-skyblue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #409eff;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-blue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #d9ecff;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
    display: block;
  }
}
.bg-yellow {
  margin: 0px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #FFFBDD;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
    display: block;
  }
}
.bg-gray {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  background: #91939a;
  color: white;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-small-blue {
  background: #B3D9FF;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-block {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-green {
  background: #28a745;
  color: white;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-red {
  background: #D73A49;
  color: white;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-danger {
  background: #f56c6d;
  color: white;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-b3d9ff {
  background: #b3d9ff;
}
.bg-warning {
  background: #e6a23d;
  color: white;
  .label {
    color: white;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-sky-blue {
  background: #409EFF;;
  color: white;
  .label {
    color: white;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
::v-deep .edit-container{
  padding: 0px!important;
}
.tr-margin{
  margin-bottom: 10px;
}
.setting-menu{
  list-style: none;
  background: #FFFFFF;
  //border: 1px solid #E1E4E8;
  border-radius: 6px;
  z-index: 100;
  margin-top: 0!important;
  position: absolute;
  margin-left: 22px;
  box-shadow: 0 1px 8px 0 rgba(27, 31, 35, 0.4);
  //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);

  li{
    width: 256px;
    height: 33px;
    background: #FFFFFF;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #24292E!important;
    box-shadow: inset 0px -1px 0px #E1E4E8;
    cursor: pointer;
    .with-icon{
      width: 11px!important;
    }
    i{
      width: 11px;
    }
    span{
      margin-left: 10px;
    }
    &:last-child{
      box-shadow: none!important;
    }
  }


}
.button-group{
  background: #FAFBFC;
  display: flex;
  border: 1px solid rgba(27, 31, 35, 0.15);
  box-sizing: border-box;
  box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);
  border-radius: 6px 6px 6px 6px;
  height: 32px;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;

  .span-one{
    .icon{
      font-family: Font Awesome 5 Free;
      font-style: normal;
      font-weight: 900;
      font-size: 14px;
      line-height: 16px;
      /* identical to box height, or 114% */

      display: flex;
      align-items: center;
      text-align: center;

      /* btn/outline/text */

      color: #0366D6;
    }
    span{
      margin-left: 10px;
    }
    color: #0366D6;
    border-right: 1px solid #E1E4E8;
    width: 60%;
    align-items: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    height: 100%;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
  }
  .span-two{
    color: #24292E;
    width: 40%;
    align-items: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    height: 100%;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    span{
      margin-right: 10px;
    }
  }
}
.bg-green {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #68C23A;
  color: white;
  p {
    padding-bottom: 5px;
  }
}
.bg-warning {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #e6a23d;
  color: white;
  p {
    padding-bottom: 5px;
  }
}
.bg-skyblue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #409eff;
  color: white;
  p {
    padding-bottom: 5px;
  }
}
.bg-blue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #d9ecff;
}
.bg-gray {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  background: #91939a;
  color: white;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
}
.bg-small-blue {
  background: #B3D9FF;
}
.bg-block {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  //display: flex;
  //flex-direction: column;
}
.bg-green {
  background: #28a745;
  color: white;
}
.bg-red {
  background: #D73A49;
  color: white;
}
.bg-danger {
  background: #f56c6d;
  color: white;
}
.bg-b3d9ff {
  background: #b3d9ff;
}
.bg-warning {
  background: #e6a23d;
  color: white;
  .label {
    color: white;
  }
}
.bg-sky-blue {
  background: #409EFF;;
  color: white;
  .label {
    color: white;
  }
}
.border-left-blue {
  border-left: 5px solid #409EFF;
}
.border-left-warning {
  border-left: 5px solid #E6A23D;
}
.border-left-success {
  border-left: 5px solid #68C23A;
}
.box {
  //margin-top: 15px;
  .title{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
  }
  .box-show{
    background: #F6F8FA;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    .title{
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #24292E;
    }
    .email{
      word-break: break-all;
      position: relative;
      .tips{
        position: absolute;
      }
    }
  }
}

.span-status{
  padding: 2px 10px;
  color: #fff;
  border-radius: 50px;
  font-size: 14px;
  margin-right: 10px;
}
.yellow{
  background-color: #DBAB09;
}
.purple{
  background-color: #6F42C1;
}
.green{
  background: #28A745;
  color: #28A745!important;
}
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  //height: 50px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 30px;
  border: 1px solid rgba(23, 111, 44, 0.2);
  border-radius: 6px;
  &.snoozed {
    background: #E6A23D;
  }
  &.resolved {
    background: #DCFFE4;
    color: #24292E;
  }
  .check{
    color: #28A745!important;
  }
  .status-title {
    padding: 22px 0;
    span {
      display: flex;
      align-items: center;
    }
  }
  .svg-inline--fa {
    padding-right: 10px;
    color: white;
    font-size: 22px;
  }

}
.margin-top-none{
  margin-top: 0!important;
}
.main-header{
  background-color: #FFF!important;
  .button-radius{
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #24292E;
    padding: 1px 8px;
    background: #FFFFFF;
    border: 1px solid #6A737D;
    border-radius: 100px;
  }
  .ticket-number{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    height: 20px;
  }
  .header-title{
    h3{
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
    }
  }
  .flex-inline{
    align-items: flex-end;
  }
  .header-date{
    //height: 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    //line-height: 20px;
    color: #586069;
    margin-right: 0;
  }
  .number-fontsize{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    //line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    margin-left: 8px;
    margin-right: 15px;
  }
}
.add-policy-list {
  margin-top: 15px;
  .add-policy-item {
    margin-bottom: 15px;
    font-size: 12px;
    color: white;
    .add-policy-label {
      display: block;
      padding-bottom: 5px;
      cursor: pointer;
      .ic-right {
        margin-left: 5px;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .bold {
      font-weight: bold;
    }
  }
}
.button-margin{
  margin-right: 8px!important;
}
.icon-backgroud-none{
  background: none!important;
  img{
    height: auto!important;
  }
}
.policy-span-status {
  background: none;
  border: 0px!important;
  &.green {
    color: #28a745!important;
  }
  &.orange {
    color: #E36209!important;
  }
  &.yellow-dark {
    color: #DBAB09!important;
  }
  &.blue {
    color: #0366D6!important;
  }
  &.red {
    color: #d73a49!important;
  }
  &.min-green {
    color: #dcffe4;
  }
  &.purple {
    color: #6F42C1;
  }
}
.plan-name{
  text-decoration: none!important;
}
.flex-icon{
  width: 70px;
  margin-right: 5px;
  display: flex;
  .icon{
    margin-right: 10px!important;
  }
  .icon-margin-top{
    margin-top: -1px;
  }
  //con-width{
  //  width: 22px;
  //  margin-right: 10px;
  //}
}

.status-box{
  padding: 15px;
  width: 280px;
  border-radius: 15px;
  &.yellow-bg{
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
  }
  &.blue-bg{
    background: #DBEDFF;
    border: 1px solid rgba(4, 66, 137, 0.2);
  }
  &.green-bg{
    background: #DCFFE4;
    border: 1px solid rgba(23, 111, 44, 0.2);
  }
  &.red-bg{
    background: #FFE3E6;
    border: 1px solid rgba(158, 28, 35, 0.2);
  }
  .box-title{
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    height: 20px;
  }
  .tips{
    font-weight: 400;
    font-size: 14px;
    margin-top: 10px;
  }
  .btn{
    margin-top: 10px;
    .el-button{
      height: 32px;
      border-radius: 6px;
      font-weight: 600;
      font-family: 'inter';
    }
    .green-btn{
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      color: #FFFFFF;
      /deep/.icon{
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .gray-red-btn{
      color: #D73A49;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    }
    .gray-black-btn{
      color: #24292E;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      /deep/.icon{
        color: #586069;
      }
    }
    .el-button+.el-button{
      margin: 0;
      margin-top: 10px;
    }
  }
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
}
</style>

